import { render, staticRenderFns } from "./ShipmentActionModal.vue?vue&type=template&id=7108fd86&scoped=true&"
import script from "./ShipmentActionModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7108fd86",
  null
  
)

export default component.exports